import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {DatabaseProvider} from "../../providers/database/database";
import {AuthProvider} from "../../providers/auth/auth";

@IonicPage()
@Component({
  selector: 'page-admin-prescriptions-note',
  templateUrl: 'admin-prescriptions-note.html',
})
export class AdminPrescriptionsNotePage {

  is_not_clinic_user: boolean;
  clinic_note: string;
  pharma_note: string;
  pharma_note_kroll: any[];
  pharma_note_user: any;
  user: any;
  public pharmacist_note: FormControl;
  public editNote: FormGroup;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public viewCtrl: ViewController,
              formBuilder: FormBuilder,
              public database: DatabaseProvider,
              private readonly auth: AuthProvider)
  {
    this.clinic_note = navParams.data.rx.note;
    this.pharma_note = navParams.data.rx.pharmacist_note;
    this.pharma_note_user = navParams.data.rx.pharmacist_note_user? navParams.data.rx.pharmacist_note_user.display_name : "";
    this.pharma_note_kroll = navParams.data.rx.pharmacist_note_kroll ? navParams.data.rx.pharmacist_note_kroll : [];
    this.pharmacist_note = new FormControl("");
    this.editNote = formBuilder.group({pharmacist_note: navParams.data.rx.pharmacist_note});
    this.editNote.patchValue(navParams.data);
    auth.getCurrentUser().then(user => {
      this.user = user;
    });
    this.is_not_clinic_user = navParams.data.is_not_clinic_user;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad AdminPrescriptionsNotePage');
  }

  submitNote() {
    console.log(this.editNote.value);
    this.database.editPrescriptionNote(this.editNote.value, this.navParams.data.rx.rx_id, this.user).then(
      () => this.viewCtrl.dismiss()
    );
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }
}



// WEBPACK FOOTER //
// ./src/pages/admin-prescriptions-note/admin-prescriptions-note.ts